import React, { useState } from "react";
import "./OurService.css";
import "@fontsource/manrope"; // Default weight is 400

const OurService = () => {
  const [formData, setFormData] = useState({
    email: '',
    mobile: '',
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'email':
        if (!value.trim()) {
          error = '*Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          error = '*Please enter a valid email address.';
        }
        break;
      case 'mobile':
        if (!value.trim()) {
          error = '*Mobile number is required.';
        } else if (!/^\d{10}$/.test(value)) {
          error = '*Please enter a valid 10-digit mobile number.';
        }
        break;
      default:
        break;
    }
    return error;
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) newErrors[field] = error;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    const fieldError = validateField(name, value);
    setErrors({
      ...errors,
      [name]: fieldError,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (validateForm()) {
    try {
      const response = await fetch('https://formsubmit.co/contact@sammarshya.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData).toString(),
      });
      if (response.ok) {
        setSubmitted(true);
        setFormData({ email: '', mobile: '' });
        setErrors({});
      } else {
        alert('Failed to send message. Please try again later.');
      }
    } catch (error) {
      alert('An error occurred. Please try again.');
    }
  }
};


  return (
    <div className="our-service-page">
      <header className="top-header">
        <h1>OUR SERVICES</h1>
        <p>Tailored to you — we create custom software specifically designed to meet your unique business needs.</p>
      </header>
      <hr className="our-service-hr" />
      <div className="our-service-container">
        <div className="left-side">
          <h2>Order a free consultation - Our experts will select the most effective solution</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-control">
              <input
                type="email"
                name="email"
                placeholder="Email*"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error-text">{errors.email}</p>}
            </div>
            <div className="form-control">
              <input
                type="text"
                name="mobile"
                placeholder="Mobile Number*"
                value={formData.mobile}
                onChange={handleChange}
              />
              {errors.mobile && <p className="error-text">{errors.mobile}</p>}
            </div>
            <div className="form-actions">
              <button type="submit">Order Consultation</button>
            </div>
            {submitted && <p className="success-text">Message sent successfully!</p>}
          </form>
        </div>
        <div className="vertical-line-service"></div>
        <div className="right-side">
 
          {/* First Service */}
          <div className="our-service-section">
            <div className="id-service">01/</div>
            <h3>Evaluation & Design</h3>
            <p className="service-p">
              Our Evaluation & Design process serves as a solid foundation for the successful
              development and deployment of custom software solutions.
            </p>
            <div className="tags">
              <span>RESEARCH & DEVELOPMENT</span>
              <span>SCOPING SESSION</span>
              <span>UI REVIEW</span>
              <span>UI DESIGN</span>
              <span>BRANDING</span>
              <span>PRODUCT DESIGN</span>
            </div>
          </div>
          <hr className="right-line-service" />

           {/* Second Service */}
           <div className="our-service-section">
            <div className="id-service">02/</div>
            <h3>Custom Software</h3>
            <p className="service-p">
              Our Custom Software process ensures tailored solutions for your
              business needs.
            </p>
            <div className="tags">
              <span>CRM DEVELOPMENT</span>
              <span>ERP SOFTWARE</span>
              <span>CLOUD APP</span>
              <span>WEBAPP</span>
              <span>BRANDING</span>
              <span>PRODUCT DEVELOPMENT</span>
              <span>NFT MARKETPLACE</span>
            </div>
          </div>
          <hr className="right-line-service"/>

          {/* Third Service */}
          <div className="our-service-section">
            <div className="id-service">03/</div>
            <h3>Web Development</h3>
            <p className="service-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
            <div className="tags">
              <span>FRONTEND</span>
              <span>PHP BACKEND</span>
              <span>JAVA</span>
              <span>NODE.JS</span>
              <span>.NET</span>
              
            </div>
          </div>
          <hr className="right-line-service"/>

          {/* Fourth Service */}
          <div className="our-service-section">
            <div className="id-service">04/</div>
            <h3>Mobile Development</h3>
            <p className="service-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions
            </p>
            <div className="tags">
            <span>IOS APP</span>
            <span>ANDROID APP</span>
            <span>REACT NATIVE</span>
            <span>FLUTTER</span>
            <span>CROSS-PLATFORM</span>

            </div>
          </div>
          
          
        </div>
      </div>
    </div>
  );
};

export default OurService;
